import React, { useState, useContext, useEffect } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import {
  IconButton,
  Stack,
  Box,
  Grid,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Popover,
  Avatar,
  TextField,
  InputAdornment
} from "@mui/material";
import moment from "moment";
import { BiMinusCircle } from "react-icons/bi";
import { FaEye } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import { useMutation, useLazyQuery } from "@apollo/client";
//Import from project
import "../../Style/actionstyle.scss";
// import {currentcyFor}
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_TOBE_PAID_NOTIFICATION, GET_TOBE_PAID_SENT_HISTORY } from "../../Schema/ToPayInvoice";

export default function CreateSentToPayNotification({ editData, academicYearId, setRefetch }) {
  // console.log("editData", editData)
  const { setAlert } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [historyData, setHistoryData] = useState()
  const [anchorEl, setAnchorEl] = useState(null);
  const [toPayAmount, setToPayAmount] = useState(0);

  // console.log(toPayAmount, "toPayAmount");

  //Modal update
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setToPayAmount(editData?.paidAmount)
  }, [open])

  // ================================= Query view notification history ===============================
  const [getToBePaidSentHistory] = useLazyQuery(GET_TOBE_PAID_SENT_HISTORY, {
    onCompleted: ({ getToBePaidSentHistory }) => {
      // console.log("getToBePaidSentHistory::", getToBePaidSentHistory)
      setHistoryData(getToBePaidSentHistory)
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handlePopoverOpen = (event) => {
    getToBePaidSentHistory({
      variables: {
        input: {
          academicYearId: academicYearId,
          student_id: editData?.student_id,
          invoice_id: editData?.invoice_id,
          currentEnrollmentId: editData?.currentEnrollmentId,
          expiredDate: moment(editData?.expiredDate).format("YYYY-MM-DD"),
          incomeHead: editData?.incomeHeadId ? editData?.incomeHeadId : null,
          paidAmount: editData?.paidAmount,
          typeOfPayment: editData?.typeOfPayment
        }
      }
    });
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  // ==================================== Mutation create notification ===================================
  const [createToBePaidNotification] = useMutation(CREATE_TOBE_PAID_NOTIFICATION, {
    onCompleted: ({ createToBePaidNotification }) => {
      setLoading(false);
      // console.log("createToBePaidNotification::", createToBePaidNotification);
      if (createToBePaidNotification?.status === true) {
        setAlert(true, "success", createToBePaidNotification?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", createToBePaidNotification?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // console.log("editData::", editData)

  const handleCreateToBePaidInvoice = () => {
    setLoading(true)
    createToBePaidNotification({
      variables: {
        input: {
          academicYearId: academicYearId,
          student_id: editData?.student_id,
          invoice_id: editData?.invoice_id,
          currentEnrollmentId: editData?.currentEnrollmentId,
          expiredDate: moment(editData?.expiredDate).format("YYYY-MM-DD"),
          incomeHead: editData?.incomeHeadId ? editData?.incomeHeadId : null,
          paidAmount: editData?.paidAmount,
          verifiedAmount: parseFloat(toPayAmount),
          typeOfPayment: editData?.typeOfPayment
        }
      }
    })
  }

  return (
    <div>

      {
        editData?.isCreated ?
          <Stack direction="row" justifyContent="right">
            {/* <Tooltip title="View history notification" placement="top"> */}
            <IconButton
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              <Box className="define-container">
                <FaEye className="define-icon" />
              </Box>
            </IconButton>
            {/* </Tooltip> */}
          </Stack>
          :
          <Stack direction="row" justifyContent="right">
            <Tooltip title="Send notification" placement="top">
              <IconButton onClick={handleOpen}>
                <Box className="save-container">
                  <IoMdSend className="save-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          </Stack>
      }

      <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
        <DialogTitle sx={{ padding: "10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">Create To Pay Notification</Typography>
            </Stack>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>
                Do you really want to create this notification!
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column" spacing={1}>
                <Typography className="field-title">
                  Type of payment
                </Typography>
                <Typography>
                  {editData?.typeOfPayment}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column" spacing={1}>
                <Typography className="field-title">
                  Income head name
                </Typography>
                <Typography>
                  {editData?.incomeHeadName ? editData?.incomeHeadName : "------ : -------"}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column" spacing={1}>
                <Typography className="field-title">
                  Estimate amount
                </Typography>
                <Typography>
                  $ {editData?.paidAmount?.toFixed(2)}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Typography className="field-title">
                Verify amount
              </Typography>
              <TextField
                size="small"
                fullWidth
                type="number"
                onFocus={(e) => {
                  e.target.select();
                }}
                value={toPayAmount}
                onChange={(e) => setToPayAmount(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  inputProps: { min: 1 },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  Loading...
                </Button>
              ) : (
                <Button
                  className="btn-create"
                  fullWidth
                  onClick={handleCreateToBePaidInvoice}
                >
                  Create
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={openPopover}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Stack
          direction="row"
          padding={2}
          width={380}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1}>
                <Avatar src={historyData?.notifiedBy?.imageSrc} alt="Sender" sx={{ width: "50px", height: "50px" }} />
                <Typography className="field-title-history-topay" sx={{ paddingTop: "12px" }}>
                  {historyData?.notifiedBy?.firstName ? historyData?.notifiedBy?.firstName + " " + historyData?.notifiedBy?.lastName : "----- : ------"}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1}>
                <Typography className="field-title-history-topay">
                  Send date:
                </Typography>
                <Typography>
                  {moment(historyData?.createdAt).format("DD-MMM-YYYY")}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1}>
                <Typography className="field-title-history-topay">
                  Send time:
                </Typography>
                <Typography>
                  {moment(historyData?.createdAt).format("hh:mm a")}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Popover>

    </div>
  );
}
